import React from 'react';

import { useSubscriptionsUserActions } from '@components/modals/UserModal/store/useSubscriptionsUserStore';

import useTranslation from '@hooks/useTranslation';

import { useAssetTreeQuery } from '@services/useAssetTreeQuery';

import ChipItem from '../ChipItem/ChipItem';
import style from './style.module.scss';

const CheckedItemsBlock = ({
  showAllFacilitiesBlock,
  locationsIds,
  clearAllChecked,
  handleDelete,
  treeBlockVariant = '',
}) => {
  const { t } = useTranslation();

  const { setUserLocationList } = useSubscriptionsUserActions();
  const { data: assetTreeData } = useAssetTreeQuery();

  const getCheckedNodes = (locsIdsArr) => {
    let checkedNodes = [];
    const userLocs = [];

    if (showAllFacilitiesBlock) {
      checkedNodes = assetTreeData.facilities;
      setUserLocationList(checkedNodes);
    } else {
      locsIdsArr.forEach((id) => {
        const loc = assetTreeData.locations.find((loc) => +loc.id === +id);

        if (loc) {
          checkedNodes.push(loc);
          if (loc.levelName === 'facility') {
            const locFacility = assetTreeData.facilities.find((loc) => +loc.id === +id);
            userLocs.push(locFacility);
          } else {
            userLocs.push({ ...loc, children: [] });
          }
        }
      });
      setUserLocationList(userLocs);
    }

    return checkedNodes;
  };

  const nodes = getCheckedNodes(locationsIds);

  const getCheckedName = (item) => {
    if (item?.levelName !== 'facility') {
      return (
        <div>
          {item.name}{' '}
          <span className={style.chipItemExtra}>{item.facility?.name || item.facilityName || ''}</span>
        </div>
      );
    } else if (item && item?.name) {
      return item.name;
    } else {
      return '';
    }
  };

  const selectedTitle =
    treeBlockVariant === 'onlyFacilities'
      ? t(`Selected ${locationsIds === 1 ? 'Facility' : 'Facilities'}`)
      : t(`Selected ${locationsIds === 1 ? 'Location' : 'Locations'}`);

  return (
    <div className={style.checkedItemsBlock}>
      {showAllFacilitiesBlock && (
        <div className={style.allCheckedItemsWrapper}>
          <div className={style.allCheckedItemsBlock}>
            {nodes.map((item) => (
              <ChipItem key={item.id} name={getCheckedName(item)} disabled={true} />
            ))}
          </div>
        </div>
      )}
      {!showAllFacilitiesBlock && (
        <>
          {!!nodes.length && (
            <>
              <div className={style.checkedListInfo}>
                <span className={style.selected}>{selectedTitle}</span>
                {!!locationsIds && (
                  <span className={style.clearBtn} onClick={clearAllChecked}>
                    {t('Clear All')}
                  </span>
                )}
              </div>
              <div className={style.checkedListWrapper}>
                <div className={style.checkedList}>
                  {nodes.map((item) => (
                    <ChipItem
                      key={item.id}
                      name={getCheckedName(item)}
                      handleDelete={() => handleDelete(item.id)}
                    />
                  ))}
                </div>
              </div>
            </>
          )}
          {!locationsIds.length && (
            <div className={style.emptyLocationsBlock}>
              <p className={style.emptyLocationsBlockText}>{t('No selected facilities')}</p>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default CheckedItemsBlock;
